<template>
  <div v-if="label" class="opening-hours-status" :class="statusClass">
    <span>{{ label.label }}</span>
    <span v-if="label.additional" class="font-normal">{{
      label.additional
    }}</span>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    nid: string
    date?: Date
  }>(),
  {
    date: () => new Date(),
  },
)

const { getStatus, getStatusLabel } = useOpeningHours()

const status = computed(() => getStatus(props.nid))
const label = computed(() => getStatusLabel(status.value))

const statusClass = computed(() =>
  isOpen.value ? 'text-success' : 'text-danger',
)

const isOpen = computed(() => {
  return status.value?.isOpen
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.opening-hours-status {
  @apply block leading-none font-bold;

  span {
    &:last-child:not(:first-child) {
      @apply text-scheme-light;
    }
  }

  &:before {
    content: '';
    background: currentColor;
    vertical-align: 0.05em;
    @apply mr-[0.25em] inline-block h-[0.6em] w-[0.6em] rounded-full;
  }
}

.teaser {
  .opening-hours-status {
    @apply mt-[0.75rem];
    @apply tablet:mt-[1rem];
  }
}
</style>
